<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { authClient } from '@/lib/auth.js';

const code = ref('');
const loading = ref(false);
const error = ref('');
const router = useRouter();

async function verify() {
  if (code.value.length !== 6) {
    error.value = 'Incorrect code';
    return;
  }

  loading.value = true;
  error.value = '';

  const res = await authClient.twoFactor.verifyTotp({
    code: code.value,
  });

  loading.value = false;

  if (res.error) {
    error.value = res.error.message || 'Incorrect code';
    code.value = '';
    return;
  }

  window.location.href = '/'
}
</script>

<template>
  <div class="page">
    <div class="wrapper">


      <div class="card-form">

        <div class="logo">
          <div class="my-4" id="logo-image"></div>
        </div>
        <div v-if="error" class="alert alert-error">
          {{ error }}
        </div>

        <input
            v-model="code"
            placeholder="000000"
            maxlength="6"
            inputmode="numeric"
            pattern="[0-9]*"
            @keyup.enter="verify"
        />

        <button class="btn-button" :disabled="loading || !code" @click="verify" style="margin-top: 20px;">
          {{ loading ? 'Checking...' : 'Confirm' }}
        </button>

      </div>


      <div class="footer">
        Impact Journals, LLC
      </div>

    </div>
  </div>

</template>

